import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const WheelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
